import React from 'react';
import AuthService from './authService.js';
import TpDataImportExcludedItem from '../Domain/TpDataImportExcludedItem.js';
import SearchParams from '../Elements/SearchParams';
import TpDataImportExcludedItemSearchParams from '../Contents/ThirdParty/TpDataImportExcludedItem/TpDataImportExcludedItemSearchParams';

export default class TpDataImportExcludedItemService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      TpDataImportExcludedItemSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/TpDataImportExcludedItem/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => convertedItems.push(new TpDataImportExcludedItem(item)));
    }
    return convertedItems;
  }

  static UpsertItem(editedItem) {
    const objToSend = {
      TpDataImportExcludedItemId:
        editedItem.TpDataImportExcludedItemId === '' || editedItem.TpDataImportExcludedItemId === 0
          ? null
          : editedItem.TpDataImportExcludedItemId,
      EntityType: editedItem.EntityType,
      Pattern: editedItem.Pattern,
      PatternType: editedItem.PatternType,
      // The backend resolves this third-party source name to the TpInstanceId.
      ThirdPartyInstanceName: editedItem.ThirdPartyInstanceName,
      IsActive: editedItem.IsActive === true,
      Reason: editedItem.Reason,
    };
    const url = `/api/TpDataImportExcludedItem/Upsert/`;
    return AuthService.getInstance().CallBackendFunctionPost(url, objToSend);
  }

  static DeleteItem(id) {
    const url = `/api/TpDataImportExcludedItem/Delete/${id}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }
}
